const MODE = {
  Attend: 1,
  Leave: 2,
  Break: 3,
  Back: 4,
};

export default MODE;